import {
  CHARGER_CONNECTIVITY_HINTS, CHARGER_CONNECTIVITY_LABELS, CHARGER_CONNECTIVITY_LINKS,
  connectivityIncludes, connectivityWith, type ChargerConnectivity, type ChargerConnectivityLink,
} from '@evi/shared';

/**
 * The required connectivity choice on both registration forms (Warren,
 * 2026-10-01): "Install wizard and Submit a Location: add a required
 * connectivity choice per deployment, 'Site WiFi or ethernet' or 'EV
 * Initiative cellular', stored on each charger." Warren, 2026-10-20: both may
 * apply, so the two links are checkboxes, at least one required, and ticking
 * both stores 'both'. One answer covers every unit in the deployment. Labels
 * and hints come from @evi/shared so the forms, the deployment page and the
 * charger page say the same thing.
 */
export const CONNECTIVITY_OPTIONS: ReadonlyArray<{ value: ChargerConnectivityLink; label: string; hint: string }> =
  CHARGER_CONNECTIVITY_LINKS.map((value) => ({
    value,
    label: CHARGER_CONNECTIVITY_LABELS[value],
    hint: CHARGER_CONNECTIVITY_HINTS[value],
  }));

/** Field label above the checkboxes. */
export const CONNECTIVITY_FIELD_LABEL = 'How the chargers connect';

/** Shown when a form tries to move on without a choice. */
export const CONNECTIVITY_CHOICE_ERROR = 'Choose how the chargers connect.';

/** A form's draft value: empty until the person ticks at least one link. */
export type ConnectivityDraft = ChargerConnectivity | '';

/** Whether a link's checkbox is ticked for this draft. */
export const connectivityTicked = (draft: ConnectivityDraft, link: ChargerConnectivityLink): boolean => connectivityIncludes(draft, link);

/** The draft after ticking or unticking one link. */
export const connectivityToggled = (draft: ConnectivityDraft, link: ChargerConnectivityLink, ticked: boolean): ConnectivityDraft =>
  connectivityWith(draft, link, ticked);

/** The hint under the checkboxes once a choice is made. */
export const CONNECTIVITY_SET_HINT = 'Tick both when the site has units on each, or units use both. One answer covers every unit at this location.';
